import type { PrimitiveValue } from "@skilitics/nautilus-core";
import { isNodeValueReference, isReferencedValue, valueReference } from "@skilitics/nautilus-core-designer-data";

import { getExternalValueDescriptor } from "../externalValues.ts";
import { useGetNodeValue } from "../useGetNodeValue.ts";

/**
 * The design-time display of a configured value for builder summary/edit
 * views. A raw literal shows as itself; a reference (node value / external)
 * shows what it points to — its advertised title — rather than the referent's
 * current value; an unresolvable configured value shows as undefined (the
 * builder's invalid state).
 */
export const useValueConfigSummary = () => {
  const getNodeValue = useGetNodeValue();

  return (configuredValue: unknown): PrimitiveValue | undefined => {
    if (!isReferencedValue(configuredValue)) {
      return configuredValue === undefined || configuredValue === null
        ? undefined
        : (configuredValue as PrimitiveValue);
    }
    const reference = valueReference(configuredValue);
    return isNodeValueReference(reference)
      ? getNodeValue(reference)?.descriptor.title
      : (getExternalValueDescriptor(reference.property)?.title ?? reference.property);
  };
};
